import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { SectionHeading } from '../product/SectionHeading';
import type { CompanyCard } from '../../types/company';
type CardGridProps = {
  id: string;
  title: string;
  subtitle?: string;
  items: CompanyCard[];
  columns?: 3 | 4;
  tone?: 'white' | 'warm';
  note?: React.ReactNode;
};
export function CardGrid({
  id,
  title,
  subtitle,
  items,
  columns = 3,
  tone = 'white',
  note
}: CardGridProps) {
  const cols = columns === 4 ? 'sm:grid-cols-2 lg:grid-cols-4' : 'sm:grid-cols-2 lg:grid-cols-3';
  const cardBg = tone === 'warm' ? 'bg-white' : 'border border-canvas-line bg-white';
  return <section className={`w-full py-20 ${tone === 'warm' ? 'bg-canvas-warm' : 'bg-white'}`} aria-labelledby={id} data-id="element-281" data-mp="3ogb7ryep3064">
      <div className="mx-auto max-w-shell px-6" data-id="element-282" data-mp="6aezfmozagsb">
        <SectionHeading id={id} title={title} subtitle={subtitle} align="left" data-id="element-283" data-mp="6b82odoqao5p" />
        {note && <div className="mt-6 max-w-[620px]" data-id="element-284" data-mp="1cwsg1uiubmy">{note}</div>}
        <ul className={`mt-10 grid grid-cols-1 gap-4 ${cols}`} data-id="element-285" data-mp="1hkc64csh4tcc">
          {items.map(item => {
          const Icon = item.icon;
          const body = <>
                <span className="flex h-10 w-10 items-center justify-center rounded-[9px] border border-canvas-line bg-white text-ink transition-colors duration-150 ease-out group-hover:text-brand" data-id="element-286" data-mp="1ri9t6wylkk3d">
                  <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} aria-hidden="true" data-id="element-287" data-mp="20iy8duzq8qhu" />
                </span>
                <h3 className="mt-5 text-[17px] font-semibold tracking-[-0.02em] text-ink" data-id="element-288" data-mp="25hrjxhvge7fd">{item.title}</h3>
                <p className="mt-2 text-[14.5px] leading-[1.55] text-ink-muted" data-id="element-289" data-mp="2a882thi1ml94">{item.text}</p>
                {item.linkLabel && <span className="mt-auto inline-flex items-center gap-1.5 pt-5 text-[14px] font-semibold text-brand" data-id="element-290" data-mp="2f7b6oymaelfi">
                    {item.linkLabel}
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-291" data-mp="2o80y7q4ilpnf" />
                  </span>}
              </>;
          return <li key={item.title} data-id="element-292" data-mp="xwmd7em7n0tm">
                {item.href ? <SmartLink href={item.href} className={`group flex h-full flex-col rounded-[14px] p-6 transition-colors duration-150 ease-out hover:border-ink/25 ${cardBg}`} data-id="element-293" data-mp="xxxbiywvzgdc">
                    {body}
                  </SmartLink> : <div className={`flex h-full flex-col rounded-[14px] p-6 ${cardBg}`} data-id="element-294" data-mp="1guosh1oyhje8">{body}</div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}